module.exports = __webpack_public_path__ + "static/media/vathegioi.abc869fe.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/vathegioi.mp3
 ** module id = 688
 ** module chunks = 0
 **/